import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconEmailEnvelope = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5 4.25C3.48122 4.25 2.25 5.48122 2.25 7V17C2.25 18.5188 3.48122 19.75 5 19.75H19C20.5188 19.75 21.75 18.5188 21.75 17V7C21.75 5.48122 20.5188 4.25 19 4.25H5ZM4.82423 5.76226C4.88166 5.75418 4.94034 5.75 5 5.75H19C19.0601 5.75 19.1191 5.75423 19.1769 5.76242L12.8846 12.0547C12.3958 12.5435 11.6049 12.5434 11.1172 12.0553C9.22063 10.1573 5.95595 6.89066 4.82423 5.76226ZM3.76259 6.82194C3.75429 6.8801 3.75 6.93955 3.75 7V17C3.75 17.0601 3.75424 17.1192 3.76245 17.1771L8.94046 11.9991C7.06804 10.1255 4.68908 7.7457 3.76259 6.82194ZM4.82327 18.2376C4.88101 18.2458 4.94001 18.25 5 18.25H19C19.0601 18.25 19.1192 18.2458 19.177 18.2376L14 13.0606L13.9452 13.1154C12.8714 14.1893 11.1304 14.1907 10.0561 13.1155L10.0007 13.0601L4.82327 18.2376ZM20.2376 17.1769C20.2458 17.1191 20.25 17.06 20.25 17V7C20.25 6.93994 20.2458 6.88087 20.2376 6.82307L15.0607 12L20.2376 17.1769Z",
		fill: "currentColor"
	})
});
export { SvgIconEmailEnvelope as ReactComponent };
